// ========================================
// 📄 src/components/auth/PrivateRoute.jsx
// ========================================
import React from "react";
import { Navigate } from "react-router-dom";
import { useAuth } from "../../contexts/AuthContext";
import Navbar from "../common/Navbar";
import Footer from "../common/Footer";
import LoadingSpinner from "../common/LoadingSpinner";

const PrivateRoute = ({ children, adminOnly = false }) => {
  const { currentUser, userRole, loading } = useAuth();

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <LoadingSpinner size="lg" />
      </div>
    );
  }

  if (!currentUser) {
    return <Navigate to="/login" />;
  }

  if (adminOnly && userRole !== "admin") {
    return <Navigate to="/dashboard" />;
  }

  return (
    <div className="min-h-screen surface-base flex flex-col">
      <Navbar />
      <main className="flex-1 pt-20 pb-10">{children}</main>
      <Footer />
    </div>
  );
};

export default PrivateRoute;
